import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import get from 'lodash/get';

class Search extends Component {
  constructor() {
    super();

    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.active !== nextProps.active;
  }

  componentDidUpdate() {
    if (this.props.active) {
      this.q.focus();
    }
  }

  setFormClasses() {
    const { active, modifier, skin, modal } = this.props;
    const baseClass = 'search-form';
    let classNames = `${baseClass} ${baseClass}--${skin}`;

    if (modal) {
      classNames += ` ${baseClass}--modal`;
    }

    if (modifier) {
      classNames += ` ${baseClass}--${modifier}`;
    }

    if (active) {
      classNames += ` ${baseClass}--active`;
    }

    return classNames;
  }

  handleSearchSubmit(event) {
    event.preventDefault();

    const { modal, closeModal } = this.props;

    if (modal && closeModal) {
      closeModal(false);
    }

    this.props.search(`/search/${this.q.value}`);
    this.clearSearch(event);
  }

  clearSearch(event) {
    const { q: input } = this;
    const action = event && event.type === 'click' ? 'focus' : 'blur';
    const delay = event && event.type === 'submit' ? 200 : 0;

    setTimeout(() => {
      input.value = '';
    }, delay);

    input[action]();
  }

  render() {
    const { modal } = this.props;

    return (
      <form
        className={this.setFormClasses()}
        onSubmit={this.handleSearchSubmit}
      >
        <div
          className={`search-form__wrapper ${
            modal ? 'search-form__wrapper--modal' : ''
          }`}
        >
          <input
            name="q"
            className={`search-form__input  ${
              modal
                ? 'search-form__input--modal'
                : 'search-form__input--in-page'
            }`}
            defaultValue={get(this.props, 'searchTerm')}
            placeholder="Search"
            type="text"
            ref={input => {
              this.q = input;
            }}
          />
          <button
            type="button"
            className="search-form__clear-input icon-close"
            onClick={this.clearSearch}
          />
        </div>
      </form>
    );
  }
}

Search.defaultProps = {
  modifier: '',
  active: false,
  modal: false,
  closeModal: () => {}
};

Search.propTypes = {
  skin: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  active: PropTypes.bool,
  modal: PropTypes.bool,
  closeModal: PropTypes.func,
  search: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return {
    search(location) {
      dispatch(push(location));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/views/components/search/search.js